(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["counting-widget"] && !Shopify.designMode) return;
  try {
    
  (function ($) {
    $(document).ready(function () {
      function isInViewport($el) {
        var elementTop = $el.offset().top;
        var elementBottom = elementTop + $el.outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
      }

      function animateCount($section) {
        $section.find('.counting-widget-card').each(function () {
          var $countNumber = $(this).find('.count-number > span');
          var originalText = $countNumber.text().trim();

          var targetNumber = parseFloat(originalText.replace(/,/g, '')) || 0;

          var decimalPlaces = originalText.split('.')[1]?.length || 0;

          $({ Counter: 0 }).animate(
            { Counter: targetNumber },
            {
              duration: 1000,
              easing: 'swing',
              step: function () {
                var formattedNumber = this.Counter.toLocaleString(undefined, {
                  minimumFractionDigits: decimalPlaces,
                  maximumFractionDigits: decimalPlaces,
                });
                $countNumber.text(formattedNumber);
              },
              complete: function () {
                $countNumber.text(originalText);
              },
            }
          );
        });
      }

      function checkWidgets() {
        $('.counting-widget-main').each(function () {
          var $section = $(this);
          if (isInViewport($section) && !$section.hasClass('animated')) {
            $section.addClass('animated');
            animateCount($section);
          }
        });
      }

      $(window).on('load resize scroll', checkWidgets);
    });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews-widget"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.customer-review-slider').each(function () {
      const $slider = $(this);
      const id = $slider.data('id');

      new Swiper(this, {
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        },
        navigation: {
          nextEl: `.swiper-button-next-${id}`,
          prevEl: `.swiper-button-prev-${id}`,
        },
        pagination: {
          el: `.swiper-pagination-${id}`,
          clickable: true,
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-carousel"] && !Shopify.designMode) return;
  try {
    
  $('.event-carousel').each(function () {
    let sliderId = $(this).data('slider-id');
    let $slider = $(this);
    let sliderSelector = `.event-carousel.swiper[data-slider-id='${sliderId}']`;

    let location = $slider.data('location');
    let genre = $slider.data('genre');
    let baseUrl = apiUrl || '';
    let top = $slider.data('total-events');
    let skip = 0;

    function renderEventCard(event) {
      const $template = $slider.find('.event-card-template').first();
      const $card = $template.clone(true, true).removeClass('hidden event-card-template');
      const $event_url = `${vivenuUrl}/event/${event.url}`;
      
      $card.find('.event-image').attr('src', event.image || 'https://placehold.co/318x239');
      $card.find('.event-image').attr('alt', event.name || 'Event');
      $card.find('.event-title').text(event.name || 'Untitled Event');
      $card.find('.event-date').text(event.start ? formatDateUTCCustom(event.start, event.timezone) : '');
      $card.find('.vivenu-ticket').attr('href', addCurrentUTMsToNewUrl($event_url));
      $card.find('.vivenu-ticket').attr('title', event.name || 'Untitled Event');
      // const venueParts = [];
      // if (event.attributes?.stage) venueParts.push(event.attributes.stage);
      // if (event.locationName) venueParts.push(event.locationName);
      $card.find('.event-venue').text(event.locationName || '');
      const $ticketAlert = $card.find('.ticket-alert');
      if (event.availabilityIndicator === 'yellow') {
        $ticketAlert.text('Low Ticket Alert').addClass('bg-low-ticket-badge').show();
      } else if (event.availabilityIndicator === 'red') {
        $ticketAlert.text('Sold out').addClass('bg-black').show();
        $card.find('.event-btn').text('Join Waitlist');
      } else {
        $ticketAlert.hide();
      }

      if (event.thisWeekend) $card.find('.event-thisWeekend').removeClass('hidden');

      // if (event.saleStatus === 'onSale') $card.find('.event-sale').removeClass('hidden');
      if (event.saleStatus === 'planned') $card.find('.event-presale').removeClass('hidden');

      return $card;
    }

    function fetchEventsAndRender() {
      let apiUrl = `${baseUrl}?location=${encodeURIComponent(location)}&top=${top}&skip=${skip}&isCarousal=1`;
      if (genre) {
        apiUrl += `&genre=${encodeURIComponent(genre)}`;
      }
      apiUrl = apiUrl.replace(/%3A/g, ':');

      (async () => {
        let $wrapper = $slider.find('.swiper-wrapper');
        try {
          const response = await fetch(apiUrl);
          if (!response.ok) throw new Error('Network response was not ok');
          const data = await response.json();
          let events = data?.data?.event_data || [];

          $wrapper.find('.swiper-slide:not(.event-card-template)').remove();
          if (events.length === 0) {
            $wrapper.append('<div class="swiper-slide"><p>No events found.</p></div>');
          } else {
            events.forEach(function (event) {
              $wrapper.append(renderEventCard(event));
            });
            
            // Ad Card Injection Logic
            const eventCount = events.length;

            // Ad Card Injection Logic
            $slider.closest('.container').find('.ad-card-block').each(function () {
              const adCard = this;

              adCard.classList.add('hidden');

              // Move ad into swiper wrapper
              $wrapper.append(adCard);

              const position = parseInt(adCard.dataset.adPosition, 10);

              const eventCards = Array.from(
                $wrapper[0].querySelectorAll(
                  '.swiper-slide:not(.event-card-template):not(.ad-card-block)'
                )
              );

              if (!eventCards.length || position <= 0) {
                return;
              }

              if (position <= eventCards.length) {
                eventCards[position - 1].insertAdjacentElement('beforebegin', adCard);
              } else {
                eventCards[eventCards.length - 1].insertAdjacentElement('afterend', adCard);
              }

              adCard.classList.remove('hidden');
            });
          }

          if ($slider.hasClass('swiper-initialized')) {
            $slider[0].swiper.update();
          } else {
            new Swiper(sliderSelector, {
              slidesPerView: 1,
              spaceBetween: 20,
              breakpoints: {
                576: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                1280: {
                  slidesPerView: 4,
                  spaceBetween: 20,
                },
              },
              on: {
                afterInit: function () {
                  toggleLockedClass(this, $slider);
                },
                resize: function () {
                  toggleLockedClass(this, $slider);
                },
                slideChange: function () {
                  toggleLockedClass(this, $slider);
                },
              },
              navigation: {
                nextEl: `.swiper-button-next-${sliderId}`,
                prevEl: `.swiper-button-prev-${sliderId}`,
              },
              pagination: {
                el: `.swiper-pagination-${sliderId}`,
                clickable: true,
              },
            });
          }
        } catch (error) {
          $wrapper.empty().append(`<div class="swiper-slide"><p class="text-center">No events found.</p></div>`);
          toggleLockedClass(null, $slider);
        }
      })();
    }

    function toggleLockedClass(swiper, $container) {
      const $bottomContainer = $container.parent().find(`.bottom-container-${sliderId}`);
      const $nextBtn = $bottomContainer.find(`.swiper-button-next-${sliderId}`);

      if ($nextBtn.hasClass('swiper-button-lock')) {
        $container.addClass('is-locked');
      } else {
        $container.removeClass('is-locked');
      }
    }

    fetchEventsAndRender();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs-widget"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $(document).on('click', '.accordion-title', function () {
      $(this).next().slideToggle(500);
      $('div.accordion-description').not($(this).next()).slideUp(500);

      // Rotate the icon inside the clicked accordion title
      $(this).find('svg').toggleClass('rotate-180');
      $('.accordion-title svg').not($(this).find('svg')).removeClass('rotate-180');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-widget"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    function initGallerySlider($slider) {
      if ($slider.hasClass('slider-initialized')) return;

      var sectionId = $slider.data('section-id');
      var sliderLength = parseInt($slider.data('slider-length'), 10);
      var $arrows = $('.slickPrev-' + sectionId + ', .slickNext-' + sectionId);
      var $dots = $('.bottom-container-' + sectionId);

      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }

      $slider.on('init reInit', function (event, slick) {
        if (slick.slideCount <= slick.options.slidesToShow) {
          $arrows.hide();
          $dots.hide();
        } else {
          $arrows.show();
          $dots.show();
        }
        $slider.removeClass('flex');
      });

      $slider.slick({
        slidesToShow: sliderLength,
        slidesToScroll: sliderLength,
        dots: true,
        infinite: false,
        appendDots: $dots,
        prevArrow: '.slickPrev-' + sectionId,
        nextArrow: '.slickNext-' + sectionId,
        responsive: [
          {
            breakpoint: 1024,
            settings: { slidesToShow: 2, slidesToScroll: 2 },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              centerMode: sliderLength !== 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }

    $('.gallery-slider').each(function () {
      initGallerySlider($(this));
    });

    let resizeTimeout;
    $(window).on('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        $('.gallery-slider').each(function () {
          initGallerySlider($(this));
        });
      }, 250);
    });

    // Modal logic only bound once
    if (!window.galleryWidgetModalBound) {
      $(document).on('click', '.gallery-slider-widget .video-wrapper', function () {
        var $videoWrapper = $(this);
        var $originalVideo = $videoWrapper.find('.custom-video').first();
        var $modalVideo = $originalVideo.clone();
        var $overlay = $('.global-modal-overlay');
        var $content = $('.global-modal-content');
        $modalVideo.find('source').attr('src', $originalVideo.find('source').attr('src'));
        $modalVideo.attr('controls', true).attr('autoplay', true);

        $content.append($modalVideo);
        $('body').addClass('overflow-hidden');
        $overlay.show();
        $overlay.focus();

        setTimeout(function () {
          $modalVideo[0].play();
        }, 10);

        $('.custom-video').each(function () {
          this.pause();
          $(this).siblings('.play-icon').show();
        });
      });
      $(document).on('click', '.gallery-slider-widget .image-wrapper', function () {
        var $videoWrapper = $(this);
        var $originalVideo = $videoWrapper.find('img');
        var $modalVideo = $originalVideo.clone().removeClass('aspect-[24/10], aspect-[4/3], aspect-square');
        var $overlay = $('.global-modal-overlay');
        var $content = $('.global-modal-content');
        $content.append($modalVideo);
        $('body').addClass('overflow-hidden');
        $overlay.show();
        $overlay.focus();
      });

      $(document).on('click', '.global-modal-close, .global-modal-overlay', function (event) {
        if ($(event.target).is('.custom-video, .custom-image')) return;
        $('.global-modal-overlay .custom-video, .global-modal-overlay .custom-image').remove();
        $('.global-modal-overlay').hide();
        $('body').removeClass('overflow-hidden');
      });

      $(document).on('keydown', function (e) {
        if (
          ($('.global-modal-overlay .custom-video').length || $('.global-modal-overlay .custom-image').length) &&
          e.key === 'Escape'
        ) {
          $('.global-modal-overlay .custom-video, .global-modal-overlay .custom-image').remove();
          $('.global-modal-overlay').hide();
          $('body').removeClass('overflow-hidden');
        }
      });

      window.galleryWidgetModalBound = true;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_old"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-event-listing"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    // ------------------------
    // 1. State Variables
    // ------------------------
    let event_start_date = '';
    let event_end_date = '';
    let selectedStage = '';
    let selectedSort = '';
    let page = 1;
    const CARDS_PER_PAGE = 24;

    // Number of REAL events already loaded from API
    let eventsLoaded = 0;
    let isLoading = false;
    let _timezone = 'UTC';

    const adConfigElement = document.getElementById("event-ad-config");
    let adPositions = [];

    if (adConfigElement) {
      try {
        const adConfig = JSON.parse(adConfigElement.textContent);

        adPositions = (adConfig.ads || [])
          .map((ad) => parseInt(ad.position, 10))
          .filter((position) => Number.isInteger(position) && position > 0)
          .sort((a, b) => a - b);
      } catch (error) {
      }
    }
    const adCardMap = new Map();
    document
      .querySelectorAll(".ad-card-block[data-ad-position]")
      .forEach((adCard) => {
        const position = parseInt(adCard.dataset.adPosition, 10);
        if (Number.isInteger(position) && position > 0) {
          adCardMap.set(position, adCard);
        }
      });

    const eventList = document.getElementById('eventList');
    const template = document.querySelector('.event-card-template');
    const locationValue = $('#eventList').attr('data-events');
    const genreValue = $('#eventList').attr('data-genre');
    const baseUrl = apiUrl || ''; // 🔹 Replace with your API endpoint

    // ------------------------
    // 2. Helper Functions
    // ------------------------

    function getAdsInRange(startPosition, endPosition) {
      return adPositions.filter((position) => {
        return position >= startPosition && position <= endPosition;
      });
    }

    function getEventsRequiredForPage(pageNumber) {
      const pageStart = (pageNumber - 1) * CARDS_PER_PAGE + 1;
      const pageEnd = pageNumber * CARDS_PER_PAGE;
      const adsInPage = getAdsInRange(pageStart, pageEnd).length;
      const eventsRequired = CARDS_PER_PAGE - adsInPage;
      return eventsRequired;
    }

    function getSkipForPage(pageNumber) {
      let skip = 0;
      for (let currentPage = 1; currentPage < pageNumber; currentPage++) {
        skip += getEventsRequiredForPage(currentPage);
      }
      return skip;
    }

    function getPaginationInfo(pageNumber) {
      const pageStart = (pageNumber - 1) * CARDS_PER_PAGE + 1;
      const pageEnd = pageNumber * CARDS_PER_PAGE;
      const adsInPage = getAdsInRange(pageStart, pageEnd);
      const eventsRequired = CARDS_PER_PAGE - adsInPage.length;
      const skip = getSkipForPage(pageNumber);

      return {
        pageStart,
        pageEnd,
        adsInPage,
        eventsRequired,
        skip,
      };
    }
    function getVisualPositionForEventCount(realEventCount) {
      let visualPosition = 0;
      let eventIndex = 0;
      while (eventIndex < realEventCount) {
        visualPosition++;
        if (adPositions.includes(visualPosition)) {
          continue;
        }
        eventIndex++;
      }
      while (adPositions.includes(visualPosition + 1)) {
        visualPosition++;
      }
      return visualPosition;
    }
    generateEventSchema(locationValue);
    function updateURL(params) {
      const existingParams = new URLSearchParams(window.location.search);
      const filterParams = ['stage', 'event_start_date', 'event_end_date', 'sortOrder'];
      filterParams.forEach(param => existingParams.delete(param));
      params.forEach((value, key) => {
        existingParams.set(key, value);
      });

      let newUrl = `${window.location.pathname}`;
      if (existingParams.toString()) newUrl += `?${existingParams.toString()}`;
      window.history.replaceState({}, '', newUrl);
    }

    function resetEvents() {
      page = 1;
      if (eventList) eventList.innerHTML = '';
}

    function showLoader() {
      if (eventList) eventList.innerHTML = '<p class="loading px-2.5 text-center">Loading events...</p>';
    }

    function showNoEvents() {
      if (eventList) eventList.innerHTML = '<p class="no-events px-2.5">No events found for this filter.</p>';
      $('.load-more-btn').addClass('hidden');
      $('.events-loaded').text('');
      if (window.matchMedia('(max-width: 767px)').matches) {
        $('.total-events-mobile').addClass('hidden');
      } else {
        $('.total-events-desktop').addClass('hidden');
      }
    }

    function updateEventCount(totalEvents) {
      if (window.matchMedia('(max-width: 767px)').matches) {
        $('.total-events-mobile').text(`${totalEvents} events`).removeClass('hidden');
      } else {
        $('.total-events-desktop').text(`${totalEvents} events`).removeClass('hidden');
      }
    }

    function renderEvents(events, isReset) {
      if (isReset) eventList.innerHTML = '';

      if (!events.length && isReset) {
        showNoEvents();
        return;
      }

      _timezone = events[0].timezone;

      const fragment = document.createDocumentFragment();

      events.forEach((event) => {
        const card = template.cloneNode(true);
        card.classList.remove('hidden', 'event-card-template');
        // card.classList.add('event-card');
        card.classList.add('event-card-block');

        card.querySelector('.event-image').src = event.image || 'https://placehold.co/318x239';
        card.querySelector('.event-image').alt = event.name || 'Event';
        card.querySelector('.event-title').textContent = event.name || 'Untitled Event';
        card.querySelector('.event-date').textContent = event.start
          ? formatDateUTCCustom(event.start, event.timezone)
          : '';
        // const venueParts = [];
        // if (event.attributes?.stage) venueParts.push(event.attributes.stage);
        // if (event.locationName) venueParts.push(event.locationName);
        const event_url = `${vivenuUrl}/event/${event.url}`;
        card.querySelector('.event-venue').textContent = event.locationName || '';
        card.querySelector('.vivenu-ticket').href = addCurrentUTMsToNewUrl(event_url);
        card.querySelector('.vivenu-ticket').title = event.name || 'Untitled Event';

        switch (event.availabilityIndicator) {
          case 'yellow':
            card.querySelector('.ticket-alert').textContent = 'Low Ticket Alert';
            card.querySelector('.ticket-alert').classList.add('bg-low-ticket-badge');
            break;
          case 'red':
            card.querySelector('.ticket-alert').textContent = 'Sold out';
            card.querySelector('.event-btn').textContent = 'Join Waitlist';
            card.querySelector('.ticket-alert').classList.add('bg-black');
            break;
          default:
            card.querySelector('.ticket-alert').style.display = 'none';
        }
        if (event.thisWeekend) card.querySelector('.event-thisWeekend').classList.remove('hidden');
        // if (event.saleStatus === 'onSale') card.querySelector('.event-sale').classList.remove('hidden');
        if (event.saleStatus === 'planned') card.querySelector('.event-presale').classList.remove('hidden');

        fragment.appendChild(card);
      });

      eventList.appendChild(fragment);
     injectAdCards();
    }

    async function fetchEvents(isReset = false) {
      if (isLoading) return;
      isLoading = true;

      if (isReset) {
        eventList.innerHTML = "";
        eventsLoaded = 0;
      }

      try {
        const params = new URLSearchParams();
        if (selectedStage) params.append('stage', selectedStage);
        if (event_start_date && event_end_date) {
          params.append('event_start_date', event_start_date);
          params.append('event_end_date', event_end_date);
        }
        if (selectedSort) params.append('sortOrder', selectedSort);
        const pagination = getPaginationInfo(page);
        const { pageStart, pageEnd, adsInPage, eventsRequired, skip } = pagination;
        let requestUrl =
            `${baseUrl}` +
            `?location=${encodeURIComponent(locationValue)}` +
            `&top=${eventsRequired}` +
            `&skip=${skip}`;

        if (genreValue) {
          requestUrl += `&genre=${encodeURIComponent(genreValue)}`;
        }

        if (params.toString()) {
          requestUrl += `&${params.toString()}`;
        }
        requestUrl = requestUrl.replace(/%3A/g, ':');
        const response = await fetch(requestUrl);
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

        const data = await response.json();

        const totalEvents = data?.data?.total_events || 0;
        const events = data?.data?.event_data || [];

        // const filteredEvents = events.filter((event) => event.saleStatus === 'onSale');

        updateEventCount(totalEvents);
        renderEvents(events, isReset);
        let eventCount = $('#eventList').children(':not(.ad-card-block )').length;
        const renderedCount = eventCount;
        if (renderedCount >= totalEvents) {
          $('.load-more-btn').addClass('hidden');
        } else {
          $('.load-more-btn').removeClass('hidden');
        }

        $('.events-loaded').text(`You’ve viewed ${renderedCount} of ${totalEvents} events`);
      } catch (error) {
        console.error('Error fetching events:', error);
        if (isReset) showNoEvents();
      } finally {
        isLoading = false;
      }
    }

    function restoreFiltersFromURL() {
      const urlParams = new URLSearchParams(window.location.search);

      // Stage
      if (urlParams.get('stage')) {
        selectedStage = urlParams.get('stage');
        $(`.filter-stage-list input[value="${selectedStage}"]`).prop('checked', true);
        $('.selected-pill').attr('data-filter', selectedStage).find('.pillText').text(selectedStage);
        $('.selected-pill').removeClass('hidden').show();
        $('.filter-stage').find('summary').addClass('selected');
      }

      // Date Range
      if (urlParams.get('event_start_date') && urlParams.get('event_end_date')) {
        event_start_date = urlParams.get('event_start_date');
        event_end_date = urlParams.get('event_end_date');

        const startMoment = moment(event_start_date).utc();
        const endMoment = moment(event_end_date).utc().subtract(1, 'day');

        let picker = $('#date-filter').data('daterangepicker');
        if (picker) {
          picker.setStartDate(startMoment);
          picker.setEndDate(endMoment);
        }

        $('#date-filter').addClass('selected');
        $('#date-filter .date-label').hide();
        $('#date-filter .daterange-val')
          .show()
          .text(startMoment.format('DD MMM') + ' - ' + endMoment.format('DD MMM'));
        $('#cancelRange').removeClass('hidden');
      }

      // Sort
      if (urlParams.get('sortOrder')) {
        selectedSort = urlParams.get('sortOrder');
        let sortText = '';
        if (selectedSort === 'ASC') sortText = 'Ascending';
        else if (selectedSort === 'DESC') sortText = 'Descending';
        else sortText = 'Sort';
        $('.filter-sort').find('.select-text').text(sortText);
        if (selectedSort) {
          $('.filter-sort').addClass('active').attr('data-sortfilter', sortText);
        } else {
          $('.filter-sort').removeClass('active').removeAttr('data-sortfilter');
        }
      }
    }


  function injectAdCards() {
    if (!eventList) return;
    const currentVisualStart = (page - 1) * CARDS_PER_PAGE + 1;
    const currentVisualEnd = page * CARDS_PER_PAGE;
    const adCards = Array.from(document.querySelectorAll(".ad-card-block"));
    if (!adCards.length) return;
    const adCardMap = new Map();
    adCards.forEach((adCard) => {
      const position = parseInt(adCard.dataset.adPosition, 10);
      if (Number.isInteger(position) && position > 0) {
        adCardMap.set(position, adCard);
      }
      adCard.classList.add("hidden");
    });
    const eventCards = Array.from(
      eventList.querySelectorAll(".event-card-block:not(.ad-card-block)"),
    );
    if (!eventCards.length) return;
    adCards.forEach((adCard) => {
      if (adCard.parentElement === eventList) {
        adCard.remove();
      }
    });
    const visualItems = [];
    let eventIndex = 0;
    for (
      let visualPosition = 1;
      visualPosition <= currentVisualEnd;
      visualPosition++
    ) {
      const adCard = adCardMap.get(visualPosition);
      if (adCard) {
        visualItems.push({
          type: "ad",
          position: visualPosition,
          element: adCard,
        });
        continue;
      }
      if (eventIndex < eventCards.length) {
        visualItems.push({
          type: "event",
          position: visualPosition,
          element: eventCards[eventIndex],
        });
        eventIndex++;
      }
    }
    const fragment = document.createDocumentFragment();
    visualItems.forEach((item) => {
      if (item.type === "ad") {
        item.element.classList.remove("hidden");
      }
      fragment.appendChild(item.element);
    });
    eventList.appendChild(fragment);
    const debugOrder = visualItems.map((item) => {
      if (item.type === "ad") {
        return `AD(${item.position})`;
      }
      return "Event";
    });
    const insertedAds = visualItems.filter((item) => item.type === "ad");
  }
    // ------------------------
    // 3. Filter Handlers
    // ------------------------

    // Date Range
    function initDateRangePicker() {
      let drp = $('#date-filter').daterangepicker(
        {
          autoApply: true,
          minDate: new Date(),
          autoUpdateInput: false,
          alwaysShowCalendars: true,
          ranges: {
            Today: [new Date(), new Date()],
            Tomorrow: [
              new Date(Date.now() + 86400000),
              new Date(Date.now() + 86400000)
            ],
            'This Week': [
              new Date(),
              new Date(Date.now() + 6 * 86400000)
            ],
          },
        },
        function (start, end) {
          const startDate = start.format('YYYY-MM-DD');
          const endDate = end.format('YYYY-MM-DD');

          $('#date-filter').addClass('selected');
          $('#date-filter .date-label').hide();
          $('#date-filter .daterange-val')
          .show()
          .text(start.format('DD MMM') + ' - ' + end.format('DD MMM'));
          $('#cancelRange').removeClass('hidden');

          event_start_date = dateInTimezoneToUTC(
            startDate,
            _timezone,
            false
          );

          event_end_date = dateInTimezoneToUTC(
            endDate,
            _timezone,
            true
          );

          fetchEvents(true);
        }
      );

      return drp;
    }

    let drp = initDateRangePicker();

    $(document).on('click', '#cancelRange', function (e) {
      e.stopPropagation();
      let picker = drp.data('daterangepicker');

      $('#date-filter').removeClass('selected');
      $('#date-filter .daterange-val').text('').hide();
      $('#date-filter .date-label').show();
      $('#cancelRange').addClass('hidden');

      event_start_date = null;
      event_end_date = null;

      $('#date-filter').data('daterangepicker').remove();

      drp = initDateRangePicker();

      const urlParams = new URLSearchParams(window.location.search);
      urlParams.delete('event_start_date');
      urlParams.delete('event_end_date');
      updateURL(urlParams);

      fetchEvents(true);
    });

    // Stage filter
    $('.filter-stage-list input[type=checkbox]').on('change', function () {
      let $checkbox = $(this);
      let $pill = $('.selected-pill');

      if ($checkbox.is(':checked')) {
        $('.filter-stage-list input[type=checkbox]').not($checkbox).prop('checked', false);
        selectedStage = $checkbox.val();

        let label = $checkbox.closest('label').find('.facet-checkbox__text').text();
        $checkbox.closest('.filter-stage').find('summary').addClass('selected');

        $pill.attr('data-filter', selectedStage).find('.pillText').text(label).end().removeClass('hidden').show();
      } else {
        selectedStage = '';
        $checkbox.closest('.filter-stage').find('summary').removeClass('selected');
        $pill.addClass('hidden').hide();
      }

      const urlParams = new URLSearchParams(window.location.search);
      if (selectedStage) urlParams.set('stage', selectedStage);
      else urlParams.delete('stage');
      updateURL(urlParams);

      fetchEvents(true);
    });

    // Pill remove
    $(document).on('click', '.remove-pill', function () {
      let filterValue = $(this).closest('.selected-pill').data('filter');
      $(`.filter-stage-list input[value="${filterValue}"]`).prop('checked', false);
      $(this).closest('.selected-pill').addClass('hidden').hide();
      $('.filter-stage').find('summary').removeClass('selected');
      selectedStage = '';

      const urlParams = new URLSearchParams(window.location.search);
      urlParams.delete('stage');
      updateURL(urlParams);

      fetchEvents(true);
    });

    // Sort dropdown
    $(document).on('click', '.select-dropdown__list-item', function () {
      var $li = $(this).closest('li');
      var itemText = $(this).text();
      var itemValue = $li.data('value');
      var $filter = $(this).closest('.filter-sort');
      var $label = $filter.find('.select-text');

      if (selectedSort === itemValue) {
        $label.text('Sort');
        $filter.removeClass('active').removeAttr('open');
        selectedSort = '';

        const urlParams = new URLSearchParams(window.location.search);
        urlParams.delete('sortOrder');
        updateURL(urlParams);
        fetchEvents(true);
      } else {
        $label.text(itemText);
        $filter.attr('data-sortfilter', itemText).removeAttr('open').addClass('active');
        selectedSort = itemValue;
        fetchEvents(true);
      }
    });

    // Load more
    $(document).on('click', '.load-more-btn', function () {
        if (isLoading) {
          return;
        }
        page++;
        $(this).blur();
        fetchEvents(false);
    });

    // ------------------------
    // 4. Init
    // ------------------------
    restoreFiltersFromURL();
    fetchEvents(true);
  });
 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  $(document).ready(async function () {
    const urlParams = new URLSearchParams(window.location.search);
    const searchQuery = urlParams.get('q');
    if (!searchQuery) return;

    
    const endpoint = `${apiUrl}/search?event_name=${searchQuery}`;
    const response = await fetch(endpoint);
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const data = await response.json();
    const totalEvents = data?.data?.total_events || 0;
    const eventsList = data?.data?.event_data || [];

    // const filteredEvents = eventsList.filter((event) => event.hideInListing === false);
    const now = new Date();

    const filteredEvents = eventsList.filter(event => {
      const visibleAfterDate = event.visibleAfter
        ? new Date(event.visibleAfter)
        : null;
  
      return (
        (event.hideInListing !== true) &&
        (!visibleAfterDate || now >= visibleAfterDate)
      );
    });
    
    if (!filteredEvents.length) {
      if (eventList) eventList.innerHTML = `<p class="no-events">No events found for "${searchQuery}".</p>`;
      return;
    }
    const eventHeading = document.querySelector('.search-event-heading');
    const eventListEl = document.getElementById('eventList');
    const template = document.querySelector('.event-card-template');

    if (!template) {
      console.error('Template element not found');
      return;
    }
   
    // if(eventsList.length > 0){
    //   eventHeading.style.display = 'block';
    // } else {
    //   eventHeading.style.display = 'none';
    // }

    if (!eventListEl) {
      return;
    }
    eventListEl.innerHTML = '';
    const fragment = document.createDocumentFragment();

    filteredEvents.forEach((event) => {
      // clone template
      const card = template.cloneNode(true);
      card.classList.remove('hidden', 'event-card-template');

      // image
      card.querySelector('.event-image').src = event.image || 'https://placehold.co/318x239';
      card.querySelector('.event-image').alt = event.name || 'Event';

      // text fields
      card.querySelector('.event-title').textContent = event.name || 'Untitled Event';

      card.querySelector('.event-date').textContent = event.start
        ? formatDateUTCCustom(event.start, event.timezone)
        : '';

      card.querySelector('.event-venue').textContent = event.locationName || '';

      // button + link
      const event_url = `${vivenuUrl}/event/${event.url}`;
      card.querySelector('.vivenu-ticket').href = addCurrentUTMsToNewUrl(event_url);
      card.querySelector('.vivenu-ticket').title = event.name || 'Event';

      // availability handling
      const ticketAlert = card.querySelector('.ticket-alert');

      if (event.availabilityIndicator === 'yellow') {
        ticketAlert.textContent = 'Low Ticket Alert';
        ticketAlert.classList.add('bg-low-ticket-badge');
      } else if (event.availabilityIndicator === 'red') {
        ticketAlert.textContent = 'Sold out';
        card.querySelector('.event-btn').textContent = 'Join Waitlist';
        ticketAlert.classList.add('bg-black');
      } else {
        ticketAlert.style.display = 'none';
      }

      // flags
      if (event.thisWeekend) card.querySelector('.event-thisWeekend')?.classList.remove('hidden');

      if (event.saleStatus === 'planned') card.querySelector('.event-presale')?.classList.remove('hidden');

      fragment.appendChild(card);
    });

    eventListEl.appendChild(fragment);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-history"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    // Configuration
    const CONFIG = {
      typeFieldMap: {
        event: ['ticket', 'event_date', 'seat', 'quantity', 'unit_price', 'subtotal'],
        product: ['quantity', 'unit_price', 'subtotal'],
        ticket_fee: ['quantity', 'unit_price', 'subtotal'],
      },
      labelMap: {
        ticket: 'Ticket',
        event_date: 'Event Date',
        seat: 'Seat',
        quantity: 'Quantity',
        unit_price: 'Unit Price',
        subtotal: 'Subtotal',
      },
      currencyFields: new Set(['unit_price', 'subtotal']),
    };

    // Utility functions
    const formatCurrency = (value) => `$${Number(value).toFixed(2)}`;

    // const formatDate = (dateString) => {
    //   if (!dateString) return '-';
    //   const date = new Date(dateString);
    //   if (isNaN(date.getTime())) return dateString; // Return original if invalid
    //   const month = String(date.getMonth() + 1).padStart(2, '0');
    //   const day = String(date.getDate()).padStart(2, '0');
    //   const year = date.getFullYear();
    //   return `${month}/${day}/${year}`;
    // };

    const isEmptyValue = (value) => value === null || value === undefined || value === '' || value === 'null';

    const formatValue = (value, isCurrency) => {
      if (isEmptyValue(value)) return '-';
      // if (isDate) return formatDate(value);
      return isCurrency ? formatCurrency(value) : value;
    };

    // Component builders
    const createDetail = (label, value, isCurrency = false) => `
      <span class="inline-block text-black">
        <span class='block mb-2.5 md:mb-5 text-sm leading-none whitespace-nowrap'>${label}</span>
        <span class='block text-base'><strong>${formatValue(value, isCurrency)}</strong></span>
      </span>
    `;

    const createHeader = (orderNumber, orderTotal, orderDate) => {
      const header = document.createElement('div');
      header.className =
        'pb-[30px] flex flex-col md:flex-row justify-between md:items-center border-b border-black-20 gap-[10px]';
      header.innerHTML = `
        <div class="text-burgundy font-semibold text-xl lg:text-lg font-roboto-condensed">
          Order No. ${orderNumber}
        </div>
        <div class="text-sm text-black space-x-5">
          <span>Total: <strong>${formatCurrency(orderTotal)}</strong></span>
          <span>Ordered: <strong>${orderDate}</strong></span>
        </div>
      `;
      return header;
    };

    const createItemDetails = (item) => {
      const allowedFields = CONFIG.typeFieldMap[item.type] || [];

      return allowedFields
        .map((field) => createDetail(CONFIG.labelMap[field], item[field], CONFIG.currencyFields.has(field)))
        .join('');
    };

    const createItemRow = (item) => {
      const itemRow = document.createElement('div');
      itemRow.className =
        'flex flex-col lg:flex-row justify-between lg:items-center border-b border-black-20 last:border-b-0 py-[30px] last:pb-0 last:pt-8 gap-5';

      const name = item.type === 'event' ? item.event_name : item.product_name;

      itemRow.innerHTML = `
        <div class="flex-1 min-w-[250px]">
          <p class="font-bold text-black text-base ${item.type === 'product' ? 'capitalize' : ''}">${name}</p>
        </div>
        <div class="flex flex-col md:flex-row gap-5 md:gap-10 lg:gap-5 xl:gap-10">
          ${createItemDetails(item)}
        </div>
      `;

      return itemRow;
    };

    const createOrderCard = (order, orderDate) => {
      const card = document.createElement('div');
      card.className = 'bg-white overflow-hidden p-5 md:p-10';

      // Add header
      card.appendChild(createHeader(order.order_number, order.order_total, orderDate));

      // Add items
      const itemsContainer = document.createElement('div');
      order.items.forEach((item) => itemsContainer.appendChild(createItemRow(item)));
      card.appendChild(itemsContainer);

      return card;
    };

    // Main function
    async function getData() {
      const url = `https://${window.location.hostname}/apps/middleware`;

      try {
        const response = await fetch(url, {
          method: 'GET',
          credentials: 'include',
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: Failed to fetch orders`);
        }

        const { data: ordersData } = await response.json();

        if (!ordersData?.length) {
          console.warn('No order data received');
          const container = document.getElementById('ordersContainer');

          if (container) {
            container.innerHTML = '<div class="mt-10 text-center">No Orders Found.</div>';
          }
          return;
        }
        const container = document.getElementById('ordersContainer');
        if (!container) {
          console.error('ordersContainer element not found');
          return;
        }

        const fragment = document.createDocumentFragment();

        ordersData.forEach((orderGroup) => {
          orderGroup.orders.forEach((order) => {
            fragment.appendChild(createOrderCard(order, orderGroup.order_date));
          });
        });
        container.appendChild(fragment);
        // console.log(`Rendered ${ordersData.reduce((acc, g) => acc + g.orders.length, 0)} orders`);
      } catch (error) {
        console.error('Error fetching orders:', error.message);

        $('.error-msg').removeClass('hidden');
      }
    }

    getData();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-carousel"] && !Shopify.designMode) return;
  try {
    
  $('.promo-slider').each(function () {
    let sliderId = $(this).data('slider-id');
    let $slider = $(this);
    // Use selector string for Swiper initialization
    let sliderSelector = `.promo-slider.swiper[data-slider-id='${sliderId}']`;
    new Swiper(sliderSelector, {
      slidesPerView: 1,
      spaceBetween: 20,
      breakpoints: {
        576: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
      on: {
        afterInit: function () {
          toggleLockedClass(this, $slider);
        },
        resize: function () {
          toggleLockedClass(this, $slider);
        },
        slideChange: function () {
          toggleLockedClass(this, $slider);
        },
      },
      navigation: {
        nextEl: `.swiper-button-next-${sliderId}`,
        prevEl: `.swiper-button-prev-${sliderId}`,
      },
      pagination: {
        el: `.swiper-pagination-${sliderId}`,
        clickable: true,
      },
    });
    function toggleLockedClass(swiper, $container) {
      const $bottomContainer = $container.parent().find(`.bottom-container-${sliderId}`);
      const $nextBtn = $bottomContainer.find(`.swiper-button-next-${sliderId}`);

      if ($nextBtn.hasClass('swiper-button-lock')) {
        $container.addClass('is-locked');
      } else {
        $container.removeClass('is-locked');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["side-by-side-widget"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $(document).on('click', '.side-by-side-widget .play-icon', function () {
      let $this = $(this);
      let $wrapper = $(this).closest('.video-wrapper');
      let $widget = $this.closest('.side-by-side-widget');
      let video = $wrapper.find('.custom-video').get(0);
      let overlay = $wrapper.find('.overlay');
      let icon = $this;

      $widget.find('.custom-video').each(function () {
        if (this !== video) {
          this.pause();
          this.removeAttribute('controls');
          $(this).siblings('.play-icon').show();
          $(this).siblings('.overlay').addClass('!block');
        }
      });

      video.play();
      video.setAttribute('controls', true);
      video.setAttribute('controlsList', 'nodownload');
      icon.hide();
      overlay.removeClass('!block');

      video.onended = function () {
        video.removeAttribute('controls');
        video.currentTime = 0;
        video.load();
        video.play();
        if (video.load) {
          video.pause();
        }
        icon.show();
        overlay.addClass('!block');
      };
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-with-background-widget"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.slider-background-widget').each(function () {
      let $slider = $(this).find('.slider-with-background');
      let $prevArrow = $(this).find('.slickPrev');
      let $nextArrow = $(this).find('.slickNext');
      let $dots = $(this).find('.button-container');
      if ($(this).find('.slide-card').length > 1) {
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          appendDots: $dots,
          prevArrow: $prevArrow,
          nextArrow: $nextArrow,
          adaptiveHeight: true,
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-content-widget"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $(document).on('click', '.tabbed-content-widget .tabs div', function () {
      var tab_id = $(this).attr('data-tab');
      let $widget = $(this).closest('.tabbed-content-widget');

      this.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });

      if ($(this).hasClass('current')) {
        return;
      }
      $widget.find('.tabs div').removeClass('current');
      $widget.find('.tab-content').removeClass('current').hide();
      $(this).addClass('current');
      $widget
        .find('#' + tab_id)
        .addClass('current')
        .fadeIn();
    });

    $(document).on('click', '.tabbed-content-widget .play-icon', function () {
      let $this = $(this);
      let $wrapper = $(this).closest('.video-wrapper');
      let overlay = $wrapper.find('.overlay');
      let video = $wrapper.find('.custom-video').get(0);
      let icon = $this;

      video.play();
      video.setAttribute('controls', true);
      video.setAttribute('controlsList', 'nodownload');
      icon.hide();
      overlay.removeClass('!block');
      video.onended = function () {
        video.removeAttribute('controls');
        video.currentTime = 0;
        video.load();
        video.play();
        if (video.load) {
          video.pause();
        }
        icon.show();
        overlay.addClass('!block');
      };
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-content-with-gallery-widget"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $(document).on('click', '.tabbed-content-widget .tabs div', function () {
      var tab_id = $(this).attr('data-tab');
      let $widget = $(this).closest('.tabbed-content-widget');

      this.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });

      if ($(this).hasClass('current')) {
        return;
      }
      $widget.find('.tabs div').removeClass('current');
      $widget.find('.tab-content').removeClass('current').hide();
      $(this).addClass('current');
      $widget
        .find('#' + tab_id)
        .addClass('current')
        .fadeIn();
    });

    $(document).on('click', '.tabbed-content-widget .play-icon', function () {
      let $this = $(this);
      let $wrapper = $(this).closest('.video-wrapper');
      let overlay = $wrapper.find('.overlay');
      let video = $wrapper.find('.custom-video').get(0);
      let icon = $this;

      video.play();
      video.setAttribute('controls', true);
      video.setAttribute('controlsList', 'nodownload');
      icon.hide();
      overlay.removeClass('!block');
      video.onended = function () {
        video.removeAttribute('controls');
        video.currentTime = 0;
        video.load();
        video.play();
        if (video.load) {
          video.pause();
        }
        icon.show();
        overlay.addClass('!block');
      };
    });

    $('.tabbed-slider').each(function () {
      let sliderId = $(this).data('slider-id');
      let gallerySlider = `.tabbed-gallery-slider-${sliderId}`;
      let $slider = $(this);
      let $swiperWrapper = $slider.find('.swiper-wrapper');
      let $slides = $swiperWrapper.find('.swiper-slide');
      let slideCount = $slides.length;

      function getSlidesPerView() {
        const width = window.innerWidth;
        if (width >= 1024) return 4;
        if (width >= 640) return 2;
        return 1;
      }

      function updateItemsCenter() {
        const spv = getSlidesPerView();
        $swiperWrapper.toggleClass('justify-center', slideCount < spv);
      }

      new Swiper(gallerySlider, {
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
        },
        on: {
          afterInit: function () {
            toggleLockedClass(this, $slider);
            updateItemsCenter();
          },
          resize: function () {
            toggleLockedClass(this, $slider);
            updateItemsCenter();
          },
          slideChange: function () {
            toggleLockedClass(this, $slider);
          },
        },
        pagination: {
          el: `.swiper-pagination-${sliderId}`,
          clickable: true,
        },
        navigation: {
          nextEl: `.swiper-button-next-${sliderId}`,
          prevEl: `.swiper-button-prev-${sliderId}`,
        },
      });

      $(window).on('resize', function () {
        updateItemsCenter();
      });

      function toggleLockedClass(swiper, $container) {
        const $nextBtn = $container.nextAll(`.bottom-container-${sliderId}`).find(`.swiper-button-next-${sliderId}`);
        if ($nextBtn.hasClass('swiper-button-lock')) {
          $container.addClass('is-locked');
        } else {
          $container.removeClass('is-locked');
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
